import React, { useState, useEffect } from 'react';
import { notification, Card, Row, Col, Modal, Button } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import { markedFavouriteUnfavourite, getFavouriteServices, delAdditionalServices } from '../../api/AdditionalServices';
import UserHeader from '../../components/header/UserHeader';
import UserDrawer from '../../components/drawer/UserDrawer';
import headerLogo from '../../assets/images/MyFriendNewsLogo.svg';
import goBackButton from '../../assets/images/GoBackButtonAdditionalServices.svg';
import "../additionalservices/AdditionalServices.css";
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';
import editButton from '../../assets/images/EditIconAdditionalServices.svg';
import deleteButton from '../../assets/images/DeleteIconAdditionalServices.svg';

const PEXELS_API_KEY = 'tgeUqppJap1Zhn6VpXMzgjEQYHrEVkOYCjYR6MSQqHoOAR0t06G34eca';

const Favourites = () => {
    const [loading, setLoading] = useState(true);
    const [newsResources, setNewsResources] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const location = useLocation();
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const { backgroundColor, message, type } = location.state;
    const navigate = useNavigate();

    const fetchNewsResources = async () => {
        try {
            setLoading(true);
            const response = await getFavouriteServices();
            console.log(response);
            if (response.data && response.data.length > 0) {
                const resourcesWithImages = await Promise.all(
                    response.data.map(async (item) => {
                        const imageUrl = item.imageUrl;
                        return { ...item, imageUrl };
                    })
                );
                setNewsResources(resourcesWithImages);
            } else {
                setNewsResources([]);
                notification.info({
                    message: 'No Favourite Preferences',
                    description: 'No Favourite preferences found for this user.',
                    duration: 10
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Failed to fetch favourite resources.',
                duration: 10
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNewsResources();
    }, [refreshTrigger]);

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleGoBackButton = () => {
        navigate("/landing-page");
    };

    const handleFavoriteToggle = async (item) => {
        try {
            const payload = {
                type: item.type,
                name: item.name,
                url: item.url,
                favourite: !item.favourite
            };

            await markedFavouriteUnfavourite(payload);

            setNewsResources(prevResources =>
                prevResources.map(resource =>
                    resource.name === item.name
                        ? { ...resource, favourite: !resource.favourite }
                        : resource
                )
            );

            notification.success({
                message: 'Success',
                description: `Successfully ${payload.favourite ? 'added to' : 'removed from'} favorites.`,
                duration: 10
            });
        } catch (error) {
            console.error('Error toggling favorite:', error);
            notification.error({
                message: 'Error',
                description: 'Failed to update favorite status.',
                duration: 10
            });
        }
    };

    const handleEditButton = () => {
        setIsEditMode(true);
    };

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setModalVisible(true);
    };

    const handleModalOk = async () => {
        try {
            if (selectedItem) {
                const data = {
                    type: selectedItem.type,
                    name: selectedItem.name,
                    url: selectedItem.url,
                };
                await delAdditionalServices(data);
                notification.success({
                    message: 'Success',
                    description: `Successfully deleted ${type} resource.`,
                    duration: 10
                });
                setIsEditMode(false);
                setRefreshTrigger(prev => prev + 1);
            }
        } catch (error) {
            console.error('Error deleting additional service:', error);
            notification.error({
                message: 'Error',
                description: 'Failed to delete additional service.',
                duration: 10
            });
        } finally {
            setModalVisible(false);
        }
    };

    const handleModalCancel = () => {
        setModalVisible(false);
        setIsEditMode(false);
        setSelectedItem(null);
    };

    return (
        <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}>
            <Row justify={{ xs: "space-around", md: "space-around", lg: "space-between" }} style={{ marginBottom: 20 }}>
                <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
                    <UserHeader setDrawer={openDrawer} backgroundColor={backgroundColor} headerLogo={headerLogo} />
                </Col>
                {isDrawerOpen && (
                    <Col span={4}>
                        <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                    </Col>
                )}
            </Row>
            <Row justify="space-between" align="middle" className="go-back-button-home">
                <Col>
                    <button onClick={handleGoBackButton} className="button-styling-additonalservices">
                        <img src={goBackButton} style={{ paddingTop: '4px' }} alt="Go Back Button" />
                    </button>
                </Col>
                <Col className="col-center">
                    <span className="go-back-message">{message}</span>
                </Col>
                <Col>
                    <button onClick={handleEditButton} className="button-styling-additonalservices">
                        <img src={editButton} alt="Edit Button" />
                    </button>
                </Col>
            </Row>
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
                    <ClipLoader loading={loading} size={50} aria-label="Loading Spinner" data-testid="loader" />
                </div>) : (
                <Row gutter={[16, 16]} style={{ padding: '50px' }}>
                    {newsResources.map((item, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <Card
                                style={{
                                    borderBottomLeftRadius: '20px',
                                    borderBottomRightRadius: '20px',
                                    position: 'relative',
                                    minHeight: '320px',
                                }}
                                hoverable
                                cover={
                                    <div style={{ height: '150px', overflow: 'hidden', position: 'relative', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                                        <img
                                            alt="news cover"
                                            src={item.imageUrl || `https://picsum.photos/seed/${item.name}/300/200`}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                        {isEditMode && (
                                            <button
                                                onClick={() => handleDeleteClick(item)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-10px',
                                                    left: '14px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    zIndex: 1,
                                                    display: 'flex',
                                                    justifyContent: "flex-end",
                                                    backgroundColor: 'transparent',
                                                }}
                                            >
                                                <img src={deleteButton} alt="Delete Button" style={{ width: '40px', height: '40px' }} />
                                            </button>
                                        )}
                                    </div>
                                }
                                actions={[
                                ]}
                            >
                                <a href={item.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <div style={{ minHeight: '0px' }}>
                                        <Card.Meta
                                            title={
                                                <>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                        <span style={{ textAlign: 'center', fontWeight: 'bold', flexGrow: 1 }}>
                                                            {item.name}
                                                        </span>
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleFavoriteToggle(item);
                                                            }}
                                                        >
                                                            {item.favourite ? <HeartFilled style={{ color: 'red' }} /> : <HeartOutlined />}
                                                        </span>
                                                    </div>
                                                    <div style={{ fontSize: '16px', fontWeight: '500', color: '#1D4D7A' }}>
                                                        {item.metadata?.title}
                                                    </div>
                                                </>
                                            }
                                            description={
                                                <div>
                                                    {item.metadata?.description}
                                                </div>
                                            }
                                        />
                                    </div>
                                </a>

                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
            <Modal
                title="Confirm Deletion"
                visible={modalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText="Delete"
                okButtonProps={{ danger: true }}
                bodyStyle={{ padding: '16px' }}
                closable={false}
                footer={[
                    <Button
                        key="cancel"
                        onClick={handleModalCancel}
                        style={{ borderColor: '#d3d3d3', color: '#000', marginRight: '45px', width: '400px' }}
                    >
                        No
                    </Button>,
                    <Button
                        key="ok"
                        type="primary"
                        onClick={handleModalOk}
                        style={{
                            backgroundColor: '#ff007f',
                            borderColor: '#ff007f',
                            color: '#fff',
                            marginTop: '15px',
                            marginRight: '45px',
                            width: '400px'
                        }}
                    >
                        Delete
                    </Button>
                ]}
            >
                <div style={{ paddingTop: '16px' }}>
                    <p>Are you sure you want to delete this resource?</p>
                </div>
            </Modal>
        </div>
    );
};

export default Favourites;
